export const PROJECT_TYPES = {
  INFRASTRUCTURE_ET_TERTIAIRE: {
    value: 'Infrastructure et Tertiaire',
    fr: 'Infrastructure et Tertiaire',
    'en-US': 'Infrastructure & Tertiary',
  },
  ENSEIGNEMENT: { value: 'Enseignement', fr: 'Enseignement', 'en-US': 'Education' },
  CULTUREL_ET_SPORTIF: { value: 'Culturel et Sportif', fr: 'Culturel et Sportif', 'en-US': 'Cultural & Sport' },
  MEDICAL_ET_SOCIAL: { value: 'Medical et Social', fr: 'Medical et Social', 'en-US': 'Medical & Social' },
  LOGEMENTS: { value: 'Logements', fr: 'Logements', 'en-US': 'Housing' },
  URBANISME: { value: 'Urbanisme', fr: 'Urbanisme', 'en-US': 'Urbanism' },
};

export function getProjectTypesArray(locale) {
  return [locale === 'fr' ? 'Tous' : 'All', ...Object.values(PROJECT_TYPES).map((projectType) => projectType[locale])];
}
